import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import QRCode from 'react-qr-code';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Modal } from '../../../../components/Modal';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE, VEHICLE_OPTIONS, VEHICLE_OPTIONS2 } from '../../constants';
import { GeneratePdfButton } from '../../../../components/GeneratePdfButton/GeneratePdfButton';
import { HBox, VBox } from '../../../../components/Box';
import { selectAllOptions } from '../../selectors';
import { formatCurrencyValue, formatLicensePlate } from '../../../../utils/string';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { PriceCardFooter } from './NewAndNotUsed';
import { Loader } from '../../../../components/Loader';
import { NewAndNotUsedFooter } from './NewAndNotUsedFooter';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  font-size: 18px;
  margin: 10px auto;
  font-family: arial;
  width: 1240px;
  height: 1754px;
  color: black;

  .doc-main {
    width: 97%;
    max-width: 1240px;
    background-color: #fff;
    color: black;
    font-weight: 400;
    padding: 100px 20px 10px 0px;
    .container {
      width: 87%;
      max-width: 1240px;
    }
  }

  .idw-field {
    font-size: 12px;
  }

  .idw-field.left {
    justify-self: flex-end;
  }

  .left1 {  
    width: 60%;  

  }  
    
  .right {  
    width: 40%;  
 
  }  

  .container-logo {  
    display: flex;  
    flex-direction: row;  
  }  

  .white-container {
    
    margin-top: 10px;
  }

  .hero-section {
    display: grid;
    grid-template-columns: 65% 32%;
    grid-column-gap: 3%;

    & .hero-image {
      object-fit: 'contain';
      height: 500px;
    }
  }
  .title {
    font-size: 24px;
    margin-bottom: 50px;

  padding-left: 40px;
  }

  .title1 {
    font-size: 28px;
  }

  .option-title {
    padding-left: 40px;
    margin-bottom: 8px;
    font-size: 24px;
  }

  .vehicle-info-section {
    display: grid;
    grid-template-columns: 33% 33% 33%;
    grid-template-rows: 60px 60px;
    grid-row-gap: 30px;
    width: 100%;
    padding: 20px 0px 10px 45px;
    font-size: 20px;
    margin-top: 20px;
    background-color: #FAFBFE;


    .info-label {
      font-size: 14px;
    
      text-transform: uppercase;
      font-weight: 600;
      color: #191919;
    }

    .info-value {
      text-transform: capitalize;
      color: #191919;
      font-size: 14px;
    }
  }
  .options-section {
    padding-left: 40px;
    font-size: 20px;
    margin-bottom: 80px;

    background-color: white;
    font-size: 16px;
  }

  .b2b-price-section {
    align-items: baseline;
    margin-bottom: 48px;
    color: #fff;
  }

  .idw-field.left {  
    float: left;  
    clear: both;  
  } 

  .price-incl-options {
    width: 50%;
    font-size: 24px;
    margin-bottom: 20px;
    color: #fff;
  }

  .photo-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, auto);
    gap: 10px; /* Adjust the gap between images as needed */
  }
  .photo-container img {
    width: 100%;
    height: auto;
  }
  .photo-left,
  .photo-right {
    background-color: red; /* Remove if not needed */
  }
  .photo-right {
    margin-top: 300px;
  }

  .wegenbelasting {
    width: 50%;
    font-size: 24px;
    margin-bottom: 20px;
    align: left;
    color: #fff;
  }
`;

const STATE = {};

const numberOfVehicleOptions = VEHICLE_OPTIONS ? VEHICLE_OPTIONS.length : 0;

/* eslint-disable react/prefer-stateless-function */
class NewAndNotUsedComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get counterClockImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_import_0 counter_clock')?.url;
    console.log('counterClockimage', url);
    return url;
  }


  get frontInteriorImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_Voor interieur')?.url;
    return url;
  }

  get backInteriorImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_Achter interieur')?.url;
    return url;
  }

  get constractionPlateImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_import_0 constraction_plate')?.url;
    return url;
  }

  get leftFrontImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_general_0 left_front')?.url;
    console.log('leftFrontImageUrl', url);
    return url;
  }

  get rightFrontImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_general_0 right_front')?.url;
    console.log('rightFrontImageUrl', url);
    return url;
  }

  get rightRearImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_general_0 right_back')?.url;
    console.log('rightRearImageUrl', url);
    return url;
  }

  get leftRearImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_general_0 left_back')?.url;
    console.log('leftRearImageUrl', url);
    return url;
  }

  

    // Check if the maximum number of options has been rendered
   

  render() {
    const vehicle = this.props.vehicle;
    
 
    // TODO Avoid the problem with missed vehicle_purpose in vehicle object
    // Check /modules/Vehicles/helpers.js line 41: v.vehicle_purpose = null;
   
     
    return (
      <Modal pdfView onClose={this.props.onClose}>
        {this.state.isLoading ? (
          <Modal>
            <HBox center vCenter>
              <Loader />
            </HBox>
          </Modal>
        ) : (
          <Container>
            <VBox id={'pricecard_doc'} center vCenter className="doc-main">
              <div className="container">
              <div class="container-logo">
                <div class="left1" >
                  <p style={{marginLeft: "45px", marginTop: "150px"}}>
                  Belastingdienst <br />
                  Kingsfordweg 1 <br />
                  1043 GN Amsterdam <br />
                  </p>
                  <p style={{ marginTop: '200px', fontWeight:"600", fontSize: "18px"}} className="title">Betreft: Verklaring nieuw en ongebruikt</p>
                </div>  
                <div class="right">
                  <img src="../../../../../public/images/indewalheader.png" alt="In de Wal" style={{ width: 'auto' }} />
                
                
                </div>  
              </div>
                
                
                <VBox className="white-container">
                  

              
                  <HBox className="options-section">
                    <HBox  flexWrap>
                    <br />
                    Beste heer/mevrouw,
                    <br />
                    <br />                    
                    Hierbij verklaart In de Wal Auto's, middels onderstaande foto's, dat de ondergenoemde auto met kenteken {formatLicensePlate(vehicle.regplate)} en chassisnummer {vehicle?.vin} nooit gebruik heeft gemaakt van de openbare weg.
                    <br />
                    <div left className="vehicle-info-section">
                    {[
                      // 'regplate',
                      'brand_name',
                      'model_name',
                      'vin',
                      'regplate',
                      'mileage',
                      'date_first_allowance',
                     
                      // 'vin',
                    ].map(property => {
                      return (
                        vehicle[property] && (
                          <VBox key={property}>
                            <div className="info-label">{this.lbl(`vehicle.property.${property}`)}:</div>
                            <div
                              className="info-value"
                              style={{ textAlign: 'left', width: '50%', textTransform: 'capitalize' }}
                            >
                              {property === 'regplate'
                                ? formatLicensePlate(vehicle.regplate)
                                : property === 'mileage'
                                ? parseInt(vehicle.mileage || '0').toLocaleString() + ' km'
                                : property === 'transmission_type'
                                ? vehicle.transmission_type === 'automatic'
                                  ? 'Automatisch'
                                  : 'Manueel'
                                : vehicle[property]}
                            </div>
                          </VBox>
                        )
                      );
                    })}
                  </div>
                    <br />
                    Tevens bevestigen wij dat deze auto op het moment van de aanvraag de exportstatus heeft na tenaamstelling in het kentekenregister.
                    <br />
                    <br />
                    Met vriendelijke groet,
                    <br />
                    <br />
                    Namens in de Wal Auto's B.V.,
                    <br />
                    Marc Douma
                  </HBox>
                  </HBox>
                  <HBox>
             
                  <div class="photo-container">
                  {!this.leftFrontImageUrl ? (
                    <>
                      <img
                      src={`https://vindat.indewal.nl/storage/documents/spin/${vehicle?.id}/1-1.jpg`} 
                      alt="Vehicle general image"
                      />
                      <img
                      src={`https://vindat.indewal.nl/storage/documents/spin/${vehicle?.id}/1-3.jpg`}                         
                      alt="Vehicle general image"
                      />
                        <div class="photo-right">
                          <img
                          src={`https://vindat.indewal.nl/storage/documents/spin/${vehicle?.id}/1-5.jpg`}                      
                          alt="Vehicle general image"
                          />
                        </div>
                        <div class="photo-right">
                          <img
                          src={`https://vindat.indewal.nl/storage/documents/spin/${vehicle?.id}/1-7.jpg`} 
                          alt="Vehicle general image"               
                          />
                        </div>
                        </>
                    ) : (
                      <>
                        <img
                      src={this.leftFrontImageUrl}
                      alt="Vehicle general image"
                    />
                       <img
                      src={this.rightFrontImageUrl}
                      alt="Vehicle general image"
                    />
                    <div class="photo-right">
                       <img
                      src={this.rightRearImageUrl}
                      alt="Vehicle general image"
                    />
                    </div>
                    <div class="photo-right">
                       <img
                      src={this.leftRearImageUrl}
                      alt="Vehicle general image"
                    />
                    </div>
                    </>
                  )}   
                         <img
                      src={`https://vindat.indewal.nl/storage/documents/spin/${vehicle?.id}/1-4.jpg`} 
                      alt="Vehicle general image"
                      />
                      <img
                      src={`https://vindat.indewal.nl/storage/documents/spin/${vehicle?.id}/1-6.jpg`}                         
                      alt="Vehicle general image"
                      />
                    <img
                      src={this.counterClockImageUrl}
                      alt="Vehicle general image"
                    />
                    <img
                      src={this.constractionPlateImageUrl}
                      alt="Vehicle general image"
                    />

                    <img
                      src={this.backInteriorImageUrl}
                      alt="Vehicle general image"
                    />

                    <img
                      src={this.frontInteriorImageUrl}
                      alt="Vehicle general image"
                    />

                  </div>
                 
                  
                </HBox>

                  <HBox style={{ backgroundColor: '#fff' }}>
                    <NewAndNotUsedFooter footerText={env.pricecard_footer_text} />
                  </HBox>
                </VBox>
              </div>
            </VBox>
          </Container>
        )}
        <GeneratePdfButton
          //generateDirectly
          sectionId={'pricecard_doc'}
          label={'PDF'}
          widthMn={210}
          heightMm={297}
          closeModal={this.props.onClose}
          setLoading={loading => this.setState({ isLoading: loading })}
        />
      </Modal>
    );
  }
}

NewAndNotUsedComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loadingChecks: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    allOptions: selectAllOptions(),
  });

function truncateAndExcludeLastWord(inputString, maxLength) {
  // Controleer of de inputString de maximale lengte niet overschrijdt
  if (inputString.length <= maxLength) {
    return inputString;
  }

  // Zoek de laatste spatie vóór de maximale lengte
  let lastSpaceIndex = inputString.lastIndexOf(' ', maxLength);

  // Als er geen spatie is gevonden, gebruik dan de maximale lengte
  if (lastSpaceIndex === -1) {
    lastSpaceIndex = maxLength;
  }

  // Knip de string af op het laatste spatiepunt
  const truncatedString = inputString.substring(0, lastSpaceIndex);

  return truncatedString;
}

function getLowestNumber(inputString) {
  // Extract numbers from the input string
  const numbers = inputString.match(/\d+/g);

  // Convert the extracted numbers to an array of integers
  const numericValues = numbers.map(value => parseInt(value, 10));

  // Find the minimum value
  const min = Math.min(...numericValues);

  return min;
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const NewAndNotUsed = compose(withConnect, withRouter)(NewAndNotUsedComp);
